import React from 'react'
import { getPresentationContentStyles, Grid, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import type { LabelsOption } from '@paintscout/util/builder'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'

const useStyles = makeStyles<Theme, WorkOrderPlaceholderProps>(
  (theme) => ({
    root: {
      '&$root': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 125,
        backgroundColor: theme.palette.grey[100],
        ...getPresentationContentStyles(theme, { noMargins: ['li'] })
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      textAlign: 'center'
    }
  }),
  { name: 'WorkOrderPlaceholder' }
)

export interface WorkOrderPlaceholderProps {
  classes?: StyleClasses<typeof useStyles>
  objectLabels: LabelsOption
}

function WorkOrderPlaceholder(props: WorkOrderPlaceholderProps) {
  const classes = useStyles(props)
  const { objectLabels } = props

  return (
    <div className={classes.root}>
      <Grid className={classes.container} container spacing={1}>
        <Grid item xs={8}>
          <AssignmentOutlinedIcon />
        </Grid>
        <Grid item xs={8}>
          <Typography variant={'h2'}>{objectLabels.workOrder.value}</Typography>
        </Grid>
        <Grid className={classes.container} item xs={5}>
          <Typography
            variant={'subtitle1'}
          >{`${objectLabels.workOrder.plural} are inserted automatically.`}</Typography>
          <Typography variant={'subtitle1'}>
            {`When viewing or sending, the ${objectLabels.workOrder.value.toLowerCase()} will be inserted wherever this placeholder is set in the presentation.`}
          </Typography>
        </Grid>
        <Grid className={classes.container} item xs={6}></Grid>
      </Grid>
    </div>
  )
}

export default WorkOrderPlaceholder
